import axios from 'axios'

const Upload = function () {
  return {
    formData: {}
    , inputClass: ''
    , bindDom: Object
    , fileInput: Object
    , canvas: Object
    , context: Object
    , beforeDealCallback: undefined
    , afterDealCallback: undefined
    , requestCallback: undefined
    , errorCallback: undefined
    , formDatas: Object
    , deals: null // loading
    , limits: 20 // 单次最大上传个数
    , allSize: 8, // 单次上传总质量 8M
    // 动态添加文件并激活
    addFile () {
      var that = this
      var input = document.createElement('input')
      that.inputClass = input.className = 'hideFilesInput' + that.randomString(100)
      input.style.cssText = 'display: none;'
      input.type = 'file'
      input.multiple = 'multiple'
      input.accept = 'image/*'

      input.onchange = function () {
        that.picPreview(this)
      }
      // 加入file
      that.bindDom.parentNode.appendChild(input)
      that.fileInput = input
    },
    // form提交 预处理
    beforeSubmit () {
      var that = this
      var fileAll = that.formData['imglist']
      var formData1 = new FormData()
      if (fileAll.length > this.limits) {
        var msgStr = '单次上传不得超过' + this.limits + '个文件！'

        that.errorCallback(msgStr)
        return
      }
      if (fileAll.length <= 0) {
        that.errorCallback('没有可以上传的文件')
      } else {
        // 这是原图 方式一
        var nameArr = ''
        for (let j = 0; j < fileAll.length; j++) {
          nameArr += (fileAll[j].name || '').replace('#', '') + '#'
        }
        formData1.append('Filename', nameArr)
        for (let key in this.formDatas) {
          formData1.append(key, this.formDatas[key])
        }
        // 使用原图来处理 方式 三
        var num = fileAll.length
        console.log(that.formData['imglist'])
        var allSize = 0
        for (let i = 0; i < num; i++) {
          var bolbs = that.getBlobs(fileAll[i].src)
          var name = fileAll[i].newName === undefined ? fileAll[i].name : fileAll[i].newName + '.jpg'
          name = name.replace('#', '')
          try {
            allSize += bolbs.size || fileAll[i].size
          } catch (e) {
            allSize += fileAll[i].size
          }
          formData1.append('files', bolbs, name)
        }
        if (allSize > this.allSize * 1024 * 1024) {
          var msgStr1 = '单次上传文件总大小不得超过' + this.allSize + 'M！'
          that.errorCallback(msgStr1)
          return
        }

        if (typeof that.requestCallback === 'undefined') {
          that.formSubmit(fileAll, formData1)
        } else {
          that.requestCallback(fileAll, formData1)
        }
        /* for (let i = 0; i < num; i++) {
          var img = new Image()
          img.src = window.URL.createObjectURL(fileAll[i])
          var name = fileAll[i].newName === undefined ? fileAll[i].name : fileAll[i].newName + '.jpg'
          name = name.replace('#', '');
          // pdf不压缩
          (function (name, img) {
            img.onload = function () {
              var base64 = that.compressPic(img)
              var bolbs = that.getBlobs(base64[0])
              formData1.append('files', bolbs, name)
              n++
              if (n === num) {
                // that.deals.close()
                that.formSubmit(fileAll, formData1)
              }
            }
          })(name, img)
        } */
      }
    },
    // 图片压缩 内置使用
    compressPic (img, mw, mh) {
      var that = this
      // 图片原始尺寸
      var n = 1
      var requireWidth = 1440// 最大宽度
      var originWidth = img.width
      var originHeight = img.height
      if (originWidth > requireWidth) {
        n = originWidth / requireWidth
        originWidth = requireWidth
      } else {
        n = 1
      }
      originHeight = parseInt(originHeight / n)
      // 最大尺寸限制
      // var maxWidth = 400, maxHeight = 400
      var maxWidth = mw === undefined ? originWidth : mw
      var maxHeight = mh === undefined ? originHeight : mh
      // 目标尺寸
      var targetWidth = originWidth
      var targetHeight = originHeight
      // 图片尺寸超过400x400的限制
      if (originWidth > maxWidth || originHeight > maxHeight) {
        if (originWidth / originHeight > maxWidth / maxHeight) {
          // 更宽，按照宽度限定尺寸
          targetWidth = maxWidth
          targetHeight = Math.round(maxWidth * (originHeight / originWidth))
        } else {
          targetHeight = maxHeight
          targetWidth = Math.round(maxHeight * (originWidth / originHeight))
        }
      }

      // canvas对图片进行缩放
      that.canvas.width = targetWidth
      that.canvas.height = targetHeight
      // 清除画布
      that.context.clearRect(0, 0, targetWidth, targetHeight)
      // 图片压缩
      that.context.drawImage(img, 0, 0, targetWidth, targetHeight)
      var type = 'image/jpeg'
      // 将canvas元素中的图像转变为DataURL
      var quality = 0.5
      var dataurl = that.canvas.toDataURL(type, quality)

      // 在进行一个原图片的base64返回
      that.canvas.width = originWidth
      that.canvas.height = originHeight
      // 清除画布
      that.context.clearRect(0, 0, originWidth, originHeight)
      // 图片压缩
      that.context.drawImage(img, 0, 0, originWidth, originHeight)
      // 将canvas元素中的图像转变为DataURL
      quality = 1
      var originDataurl = that.canvas.toDataURL(type, quality)

      return [dataurl, originDataurl]
    },
    // formData时转换使用 内置使用
    getBlobs (base64) {
      var base64String = base64
      // 这里对base64串进行操作，去掉url头，并转换为byte
      var bytes = window.atob(base64String.split(',')[1])
      var array = []
      for (var i = 0; i < bytes.length; i++) {
        array.push(bytes.charCodeAt(i))
      }
      var blob = new Blob([new Uint8Array(array)], {type: 'image/jpeg'})
      return blob
    },
    // 正式提交
    formSubmit (fileAll, formData1) {
      var that = this
      axios.post('../UploadImagesHandlerNew.ashx', formData1)
        .then(function (response) {
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 图片处理
    picPreview (obj) {
      var that = this
      if (obj.files) {
        var fileAll = obj.files
        console.log(fileAll)
        var imgs = fileAll
        for (var i = 0; i < imgs.length; i++) {
          // if ((imgs[i].type + '').indexOf('pdf') > -1 ||
          if ((imgs[i].type + '').indexOf('jpg') > -1 ||
            (imgs[i].type + '').indexOf('jpeg') > -1 ||
            (imgs[i].type + '').indexOf('gif') > -1 ||
            (imgs[i].type + '').indexOf('png') > -1 ||
            (imgs[i].type + '').indexOf('bmp') > -1) {
            // 是pdf或图片//.jpg .jpeg .gif .png .bmp
          } else {
            // alert('只允许上传图片！')
            that.errorCallback('只允许上传图片!')
            return
          }
        }

        // 如果超出最大个数
        if (fileAll.length + that.formData['imglist'].length > this.limits) {
          var msgStr = '最大允许上传' + this.limits + '个文件！'

          that.errorCallback(msgStr)
          return
        }

        // 开始执行处理前的回调
        if (that.beforeDealCallback) {
          that.beforeDealCallback()
        }

        var num = imgs.length
        var n = 0
        // console.log(this.thumbnail, num)
        for (var j = 0; j < num; j++) {
          (function (j) {
            imgs[j].id = that.randomString()
            that.formData['imglist'].push(imgs[j])

            var img = new Image()
            img.src = window.URL.createObjectURL(imgs[j])
            // var name = imgs[j].name.substring(0, imgs[j].name.lastIndexOf('.'))
            img.onload = function () {
              // var urls = that.compressPic(img, 400, 400)
              var urls = that.compressPic(img)
              n++
              // 原图片地址
              imgs[j].orgSrc = urls[1]
              // 压缩后地址
              imgs[j].packSrc = urls[0]
              // 设置压缩图片的blob
              imgs[j].blob = that.getBlobs(urls[0])
              // imgs[j].picH = that.picWW
              if (n === num) {
                // console.log(name)
                // that.thumbnailFun(imgs)
                if (that.afterDealCallback) {
                  that.afterDealCallback(imgs, that.formData['imglist'])
                }
              }
            }
          })(j)
        }
        // 删除该input重新添加一个
        obj.parentNode.removeChild(obj)
        that.addFile()
      }
    },
    // 获取随机数 内置使用
    randomString (len) {
      len = len || 32
      var $chars = 'ABCDEFGHIJKMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      var maxPos = $chars.length
      var pwd = ''
      for (var i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    // 批量删除
    plsc (delarr) {
      // console.log(delarr)
      this.formData['imglist'] = delarr
      // for (let j = 0; j < delarr.length; j++) {
      //   console.log(j)
      // }
      // for (var i = 0; i < that.formData['imglist'].length; i++) {
      //   if (that.formData['imglist'][i].id != index1) {
      //     arr.push(that.formData['imglist'][i]);
      //   }
      // }
      // that.formData['imglist'] = arr;
    }
    ,
  }
}
// 配置
const uploadConfig = function (upload) {
  return {
    /**
     * 设置上传时其他参数
     * @param params  其他请求参数列表  object
     * @returns {uploadConfig}
     */
    setRequestParams (params) {
      upload.formDatas = typeof params == 'object' ? params : {}
      return this
    }

    /**
     * 设置最大上传个数 number
     * @param limits  最大上传个数20
     * @returns {uploadConfig}
     */
    , setMaxLimits (limits) {
      upload.limits = typeof limits === 'number' ? limits || 20 : 20
      return this
    }

    /**
     * 设置最大上传总质量, 默认最大为8M
     * @param maxSize 上传总质量 number
     * @returns {uploadConfig}
     */
    , setAllSize (maxSize) {
      upload.allSize = typeof maxSize === 'number' ? maxSize || 8 : 8
      return this
    }

    /**
     * 压缩处理前回调
     * @param func
     * @returns {uploadConfig}
     */
    , setBeforeDell (func) {
      upload.beforeDealCallback = typeof func === 'function' ? func : undefined
      return this
    }

    /**
     * 压缩处理后的回调
     * @param func
     */
    , setAfterDeal (func) {
      upload.afterDealCallback = typeof func === 'function' ? func : undefined

      return this
    }

    /**
     * 设置 请求回调
     * @param func
     */
    , goRequest (func) {
      if (typeof func === 'function') {
        upload.requestCallback = func
        upload.beforeSubmit()
      } else if (func == undefined) {
        upload.beforeSubmit()
      }
    }

    /**
     * 设置出错回调
     * @param func
     */
    , setError (func) {
      upload.errorCallback = typeof func === 'function' ? func : undefined

      return this
    }

    /**
     * 设置数据集合
     * @param dataList
     * @returns {uploadConfig}
     */
    , setDataList (dataList = []) {
      upload.formData['imglist'] = dataList

      return this
    }
  }
}

const XTUpload = {
  // 开始初始化的方法 初始化一些内部使用数据
  init (selector) {
    var bindDom = document.querySelector(selector)
    console.log(bindDom)
    if (bindDom) {
      let canvas = document.createElement('canvas')
        , upload = new Upload()
      upload.canvas = canvas
      upload.context = canvas.getContext('2d')

      upload.formData['imglist'] = []
      upload.bindDom = bindDom
      upload.addFile()

      // 绑定点击事件
      bindDom.onclick = function () {
        upload.fileInput.click()
      }
      return new uploadConfig(upload)
    }

    return null
  }
}

export default XTUpload



// WEBPACK FOOTER //
// ./src/utils/XTUpload.js